import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=52cced3e&scoped=true"
import script from "./markdown.vue?vue&type=script&lang=js"
export * from "./markdown.vue?vue&type=script&lang=js"
import style0 from "./markdown.vue?vue&type=style&index=0&id=52cced3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cced3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cced3e')) {
      api.createRecord('52cced3e', component.options)
    } else {
      api.reload('52cced3e', component.options)
    }
    module.hot.accept("./markdown.vue?vue&type=template&id=52cced3e&scoped=true", function () {
      api.rerender('52cced3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/markdown.vue"
export default component.exports